import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  GetCustomPolicyDto,
  UpdateCustomPolicyDto,
  UpdateCustomPolicyProcedureDto,
} from "../types/api/api-types";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { axiosApi } from "./axios";

const getCustomPolicy = async (customsId: string) => {
  const response = await axiosApi.get<GetCustomPolicyDto>(`/v1/custom-policy/${customsId}`);
  return response.data;
};

export const useGetCustomPolicy = (customsId: string) => {
  return useQuery({
    queryKey: ["custom-policy", customsId],
    queryFn: () => getCustomPolicy(customsId),
    enabled: !!customsId,
  });
};

const updateCustomPolicy = async (data: { customsId: string; payload: UpdateCustomPolicyDto }) => {
  return axiosApi.patch(`/v1/custom-policy/${data.customsId}`, data.payload);
};

export const useUpdateCustomPolicy = () => {
  const { t } = useTranslation("boCustoms");
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateCustomPolicy,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["custom-policy", variables.customsId],
      });
      toast.success(t("customPolicyApi.updatePolicySuccess"));
    },
    onError: () => {
      toast.error(t("customPolicyApi.updateError"));
    },
  });
};

const updateCustomPolicyProcedure = async (data: {
  customsId: string;
  payload: UpdateCustomPolicyProcedureDto;
}) => {
  return axiosApi.patch(`/v1/custom-policy/${data.customsId}/procedure`, data.payload);
};

export const useUpdateCustomPolicyProcedure = () => {
  const { t } = useTranslation("boCustoms");
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateCustomPolicyProcedure,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["custom-policy", variables.customsId],
      });
      toast.success(t("customPolicyApi.updateProcedureSuccess"));
    },
    onError: () => {
      toast.error(t("customPolicyApi.updateError"));
    },
  });
};
